import { render } from "./SvgIcon.vue?vue&type=template&id=7ade3116&bindings={\"name\":\"props\",\"title\":\"props\",\"iconPath\":\"options\",\"className\":\"options\"}"
import script from "./SvgIcon.vue?vue&type=script&lang=js"
export * from "./SvgIcon.vue?vue&type=script&lang=js"

import "./SvgIcon.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script